module.exports = __webpack_public_path__ + "229f3fb9a6884bd922229098ff722cd5.MP3";